'use strict';

module.exports = {
    HotFolder: 'HOT_FOLDER',
    Schedule: 'SCHEDULE',
    Manual: 'MANUAL',
    Job: 'JOB'
};